<template>
  <div class="clearfix p-20 p-b-0">
    <div :class="['col-xs-8 col-md-6 p-0', inputClass]">
      <input
        type="search"
        class="form-control"
        :value="search"
        :placeholder="$t('CAMPAIGN_STEP_ROUTING_TARGETS_SEARCH')"
        @input="$emit('change', $event.target.value)"
      >
    </div>
    <button
      v-if="canCreateNew"
      type="button"
      class="btn btn-primary btn-sm pull-right"
      @click="$emit('create-new')"
    >
      <i
        class="typcn typcn-plus"
      />
      {{ $t('CAMPAIGN_STEP_ROUTING_TARGETS_NEW') }}
    </button>
    <button
      type="button"
      class="btn btn-sm bg-transparent letter-spacing-normal pull-right m-r-10"
      :title="$t('CALL_PLANS_REFRESH_TARGETS')"
      @click="$emit('refresh')"
    >
      <i
        class="fa fa-refresh p-0"
        :class="{'fa-spin': isRefreshing}"
      />
    </button>
  </div>
</template>

<script>

import { defineComponent } from 'vue';
import sharedMessages from '@/core/locales';
import messages from '../locales';

export default defineComponent({
  name: 'RoutingPlanTabHeader',
  model: {
    prop: 'search',
    event: 'change',
  },
  props: {
    search: String,
    isRefreshing: Boolean,
    inputClass: String,
    canCreateNew: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: [
    'refresh',
    'create-new',
  ],
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
});

</script>
